import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Link, useHistory } from 'react-router-dom';
import { Spin } from 'antd';
import moment from 'moment';
import { isNull, isUndefined } from 'underscore';
import ellipse from '../../assets/images/ellipse.svg';
import { getSelectedTranslation, getTranslation } from '../../core/utils/helpers';
import Main from '../../components/layout/Main';
import SEO from '../../components/SEO';
import { PAGE_SEO_CONFIG } from '../../components/SEO/seoConfig';
import './noticeboard.scss';

import {
    noticeboardReadStatusRequest,
    setSelectedNoticeboard,
} from '../../core/noticeboard/noticeboardActions';

const MAX_DESCRIPTION_LENGTH = 100;

const Noticeboard = () => {

    const noticeboard = useSelector(state => state.noticeboard);
    const language = useSelector(state => state.language);
    const dispatch = useDispatch();
    const history = useHistory();

    const stripHtmlTags = (html) => {
        if (!html) return '';
        return html.replace(/<[^>]*>/g, '');
    };

    const truncateText = (text, maxLength) => {
        if (!text) return '';
        const strippedText = stripHtmlTags(text);
        if (strippedText.length <= maxLength) return strippedText;
        return strippedText.substring(0, maxLength);
    };

    const getNoticeImage = (item, translation) => (
        item?.image_url || item?.image || translation?.image_url || translation?.image || null
    );

    const handleViewNotice = (item) => {
        dispatch(setSelectedNoticeboard(item));
        history.push(`/noticeboard/${item.id}`);
    };

    const markAsRead = () => {

        const unreadNoticeboard = noticeboard?.noticeboardData?.filter(item => {
            if (item?.read_at === null || item?.read_at === undefined) {
                return item.id;
            }
            return null;
        });

        if (unreadNoticeboard?.length > 0) {
            const filteredIds = unreadNoticeboard.map(item => item.id);
            dispatch(noticeboardReadStatusRequest({ filteredIds }));
        }
    };

    const renderNoticeboard = (item, index) => {

        const horoscopeTranslation = getSelectedTranslation(item.translations, language?.selectedLanguage?.id);
        const description = horoscopeTranslation?.description || '';
        const strippedDescription = stripHtmlTags(description);
        const isLongDescription = strippedDescription.length > MAX_DESCRIPTION_LENGTH;
        const noticeImage = getNoticeImage(item, horoscopeTranslation);

        return (
            <div
                key={index}
                className={isNull(item?.read_at) || isUndefined(item?.read_at) ? 'c-box c-box-highlighted c-box-clickable' : 'c-box c-box-clickable'}
                onClick={() => handleViewNotice(item)}>
                <div className="dot-icon">
                    {isNull(item?.read_at) || isUndefined(item?.read_at) ? (
                        <img src={ellipse} alt="dot" />
                    ) : null}
                </div>

                <div className="c-box-content">
                    {noticeImage && (
                        <div className="c-box-image">
                            <img src={noticeImage} alt={horoscopeTranslation?.title || 'Notice'} />
                        </div>
                    )}
                    <div className="c-box-title">
                        {horoscopeTranslation?.title}
                    </div>
                    <div className="c-box-subtitle">
                        {truncateText(description, MAX_DESCRIPTION_LENGTH)}
                        {isLongDescription && (
                            <span className="c-see-more">... {getTranslation(language, 'see_more', 'see more')}</span>
                        )}
                    </div>
                    <div className="c-date">
                        {moment(item?.created_at).format('DD/MM/YYYY')}
                    </div>
                </div>
            </div>
        );
    };

    const renderNoticeboards = () => {
        if (noticeboard?.noticeboardData?.length > 0) {
            return noticeboard?.noticeboardData?.map((item, index) => (
                renderNoticeboard(item, index)
            ));
        }
        return null;
    };

    return (
        <>
            <SEO
                title={PAGE_SEO_CONFIG.noticeboard.title}
                description={PAGE_SEO_CONFIG.noticeboard.description}
                url={PAGE_SEO_CONFIG.noticeboard.url}
                noindex={PAGE_SEO_CONFIG.noticeboard.noindex} />
            <Main
                headerTitle={(
                    <div>
                        <img style={{ height: 70, width: 70 }}
                            src="https://prakashastrologer-19e87.kxcdn.com/wp-content/uploads/2020/05/PrakashAstrologerLogo.svg"
                            alt="logo" />
                    </div>
                )}
                backLink={(
                    <Link to="/dashboard" className="backlink" />
                )}
                menuWidth={350}
                menuPlacement="right"
                floatingHeader
                displayRightMenu={false}
                showFooter={false}>
                <div className="noticeboard-detail">
                    <div className="noticeboard-heading">
                        <div className="notice-head">
                            <h2 className="c-page-heading"> {getTranslation(language, 'noticeboard', 'Noticeboard')}</h2>
                        </div>
                        <div className="c-mark-all-read-head" onClick={() => markAsRead()}>
                            <p className="c-mark-all-read">{getTranslation(language, 'mark_all_as_read', 'Mark all as read')}</p>
                        </div>
                    </div>
                    {noticeboard?.isFetching
                        ? (
                            <div className="loaderSpacer">
                                <Spin size="large" />
                            </div>
                        )
                        : renderNoticeboards()}
                </div>

            </Main>
        </>
    );
};

export default Noticeboard;
